<template lang="html">
  <div class="full-page">
    <i-header title="投资者APP操作手册" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <i-group-cell title="投资者操作流出说明" style="background:#fff;margin-bottom: 10px;">
        <i-cell @click="$_cellJump('/guide/register', '账户注册流程')" style="font-size: 14px;">账户注册流程</i-cell>
        <i-cell @click="$_cellJump('/guide/specific', '特定对象确认流程')" style="font-size: 14px;">特定对象确认流程</i-cell>
        <i-cell @click="$_cellJump('/guide/processApply', '预约申请流程')" style="font-size: 14px;">预约申请流程</i-cell>
        <i-cell @click="$_cellJump('/guide/processConfirm', '预约确认流程')" style="font-size: 14px;">预约确认流程</i-cell>
        <i-cell @click="$_cellJump('/guide/contractSign', '合同签署流程')" style="font-size: 14px;">合同签署流程</i-cell>
      </i-group-cell>
      <i-group-cell title="重要功能点说明" style="background:#fff;margin-bottom: 10px;">
        <i-cell @click="$_cellJump('/guide/relation', '邀请码关联')" style="font-size: 14px;">邀请码关联</i-cell>
        <i-cell @click="$_cellJump('/guide/auth', '身份认证')" style="font-size: 14px;">身份认证</i-cell>
        <i-cell @click="$_cellJump('/guide/risk', '风险承受能力测评')" style="font-size: 14px;">风险承受能力测评</i-cell>
        <i-cell @click="$_cellJump('/guide/reserve', '预约申请')" style="font-size: 14px;">预约申请</i-cell>
        <i-cell @click="$_cellJump('/guide/order', '创建产品(产品买产品)')" style="font-size: 14px;">创建产品(产品买产品)</i-cell>
        <i-cell @click="$_cellJump('/guide/recorde', '双录')" style="font-size: 14px;">双录</i-cell>
        <i-cell @click="$_cellJump('/guide/sign', '合同签署')" style="font-size: 14px;">合同签署</i-cell>
      </i-group-cell>
      <i-group-cell title="其他说明" style="background:#fff;margin-bottom: 10px;">
        <i-cell @click="$_cellJump('/guide/orderState', '订单状态说明')" style="font-size: 14px;">订单状态说明</i-cell>
        <i-cell @click="$_cellJump('/guide/password', '如何找回密码')" style="font-size: 14px;">如何找回密码</i-cell>
      </i-group-cell>
      <i-group-cell title="视频功能说明" style="background:#fff;">
        <i-cell @click="$_cellJump('/guide/video', '视频功能说明')" style="font-size: 14px;">视频功能说明</i-cell>
      </i-group-cell>
    </i-body>
  </div>
</template>

<script>
import cmixin from '../commonConfig';

export default {
  mixins: [cmixin],
  methods: {
    $_cellJump(url, title) {
      if (title === '视频功能说明') {
        this.$bridge.callHandler('functionSecelted', { message: '视频功能点说明', guideUrl: 'recordList' }, () => {
        });
      } else {
        this.$router.push({
          path: url,
          query: { title },
        });
      }
    },
  },
};
</script>

<style lang="css">
</style>
